


import watchNewEntradaEstoque from './saga/new';
import watchNewFilterEntradaEstoque from './saga/newFilter';
import watchNewFilterNextPageEntradaEstoque from './saga/newFilterNextPage';
import watchFindEntradaEstoque from './saga/find';
import watchCreateEntradaEstoque from './saga/create';
import watchListAllEntradaEstoque from './saga/listAll';
import watchListEntradaEstoque from './saga/listTable';
import watchDeleteEntradaEstoque from './saga/delete';
import watchReadXmlEntradaEstoque from './saga/xml/readXml';
import watchSelectProductItemXmlEntradaEstoque from './saga/xml/selectProductItemXml';
import watchViewDanfeXmlManualEntradaEstoque from './saga/xml/viewDanfeXmlManual';

export const entradaEstoqueSaga = [
    watchNewEntradaEstoque(),
    watchNewFilterEntradaEstoque(),
    watchNewFilterNextPageEntradaEstoque(),
    watchFindEntradaEstoque(),
    watchCreateEntradaEstoque(),
    watchListAllEntradaEstoque(),
    watchListEntradaEstoque(),
    watchDeleteEntradaEstoque(),
    watchReadXmlEntradaEstoque(),
    watchSelectProductItemXmlEntradaEstoque(),
    watchViewDanfeXmlManualEntradaEstoque(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
export * from './tipoDuplicataEnum';
